require('_locale')
const App = require('./App');

import React from 'react'
import {render} from 'react-dom'

render(<App/>, document.querySelector('#app'))



// WEBPACK FOOTER //
// ./src/index.js